export default __webpack_public_path__ + "static/media/325D.c2dd817e.pdf";